<template>
  <!-- <div class="flex flex-col w-full">
    <div class="flex items-center gap-4 mt-2">
      <VueSlider
        class="flex-1"
        :min="fontSizeMin"
        :max="fontSizeMax"
        :step="fontSizeStep"
        :tooltip="false"
        :modelValue="fontSize"
        @update:modelValue="val => $emit('update:fontSize', val)"
      />
      <span class="w-16 inline-block ml-2">{{ fontSize }} pt</span>
    </div>
    <div class="flex items-center gap-4 mt-4">
      <VueSlider
        class="flex-1"
        :min="shadowMin"
        :max="shadowMax"
        :step="shadowStep"
        :tooltip="false"
        :modelValue="shadowIntensity"
        @update:modelValue="val => $emit('update:shadowIntensity', val)"
      />
      <span class="w-20 inline-block ml-2">{{ shadowIntensity }} shd</span>
    </div>
  </div> -->

  <div class="mt-4 text-left">
    <div>
      <VueSlider
        class="flex-1"
        :min="fontSizeMin"
        :max="fontSizeMax"
        :step="fontSizeStep"
        :tooltip="false"
        :model-value="fontSize"
        @update:model-value="val => $emit('update:fontSize', val)"
      />
      Size: {{ fontSize }}
    </div>
    <div class="mt-4">
      <VueSlider
        class="flex-1"
        :min="shadowMin"
        :max="shadowMax"
        :step="shadowStep"
        :tooltip="false"
        :model-value="shadowIntensity"
        @update:model-value="val => $emit('update:shadowIntensity', val)"
      />
      Shadow: {{ shadowIntensity }}
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-3-slider-component'

export default {
  name: 'FontSliders',
  components: { VueSlider },
  props: {
    fontSize: { type: Number, required: true },
    shadowIntensity: { type: Number, required: true },
    fontSizeMin: { type: Number, default: 1 },
    fontSizeMax: { type: Number, default: 500 },
    fontSizeStep: { type: Number, default: 1 },
    shadowMin: { type: Number, default: 0 },
    shadowMax: { type: Number, default: 10 },
    shadowStep: { type: Number, default: 1 }
  },
  emits: ['update:fontSize', 'update:shadowIntensity']
}
</script>
